import React from 'react';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash, FaCheck } from 'react-icons/fa';
import Form from 'react-bootstrap/Form';

import FieldSelect from '../common/FieldSelect';
import RoomAPI from '../../api/RoomAPI';
import ApiUiController from '../../controller/ApiUiController';
import Display from '../../util/Display';
import Util from '../../util/Util';
import TowerConst from '../../util/TowerConst';
import withRouter from '../../util/WithRouter';
import Const from '../../util/Constants';

class InnerRoomList extends React.Component {

  static Room = 'room';
  static Refresh = 'refresh';

  constructor(props) {
    super(props);
    this.model = props.model;
    this.state = { inApiCall: true, popup: null, rooms: [], viewRooms: [], room: {} };
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
  }

  componentDidMount() { this.loadProperties(); }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.lead && props.lead.id !== this.id) {
      this.loadProperties();
    }
  }

  loadProperties = () => RoomAPI.getInnerList(this.props.type, this.props.id, 
    this.onReceived, this.props.failure, this.props.logout);

  onReceived = res => { this.setState({ ...this.state, inApiCall: false, rooms: res.data, viewRooms: res.data });}
  onDelete = indx =>  Util.confirmAlert('Delete', 'Are you sure you want to delete', 'Delete', 'No',
    () => {
      this.setState({ ...this.state, inApiCall: true });
      RoomAPI.delete( this.state.viewRooms[indx].id, this.onDeleteSuccess, this.props.failure, this.props.logout );
    }
  )

  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Property deleted successfully', 'success');
    this.props.reload();
  }

  onMassDelete = () => {
    const rooms = this.state.viewRooms.filter(room => room.checked);
    if(rooms.length > 0) {
      Util.confirmAlert('Delete', 'Are you sure you want to delete', 'Delete', 'No',
        () => {
          this.setState({ ...this.state, inApiCall: true });
          RoomAPI.massDelete(rooms.map(room => room.id), this.onDeleteSuccess, this.props.failure, this.props.logout );
        }
      )
    }
  }

  onChecked = (indx, checked) => {
    const rooms = [ ...this.state.viewRooms ];
    rooms[indx].checked = checked;
    this.setState({...this.state, viewRooms: [ ...rooms ] });
  }

  onChange = (field, value) => {
    const room = { ...this.state.room };
    room[field] = value;
    this.setState({ ...this.state, room: { ...room }});
  }

  applyFilter = () => {
    let viewRooms = [ ...this.state.rooms];
    if(this.state.room.property) {
      viewRooms = viewRooms.filter(room => room.property === this.state.room.property);
    } 

    if(this.state.room.room_status) {
      viewRooms = viewRooms.filter(room => room.room_status === this.state.room.room_status);
    }

    viewRooms = viewRooms.map(room => { return { ...room, checked: false } });

    this.setState({ ...this.state, viewRooms: [ ...viewRooms ] });
  }

  showList = () => this.state.viewRooms.map((room, _i) => (
    <tr key={`room_${_i}`}>
      <td>
        <Form.Check type="checkbox">
          <Form.Check.Input type="checkbox" checked={room.checked} 
            onChange={evt => this.onChecked(_i, evt.target.checked)} />
        </Form.Check>
      </td>
      <td>{room.room_name}</td>
      { this.model.fields.floor_no.visible ? <td>{room.floor_no}</td> : null }
      <td>{Display.FieldValue(room, 'property', this.model.fields)}</td>
      <td>{Display.FieldValue(room, 'room_status', this.model.fields)}</td>
      <td><span>{room?.customer_name ? room?.customer_name : "-"}</span></td>
      <td>{Display.ModelLabelValue('user', room.updated_by)}</td>
      <td>{Util.serverStringToDisplayDateTime(room.updated_date)}</td>
      <td>{Display.ModelLabelValue('user', room.created_by)}</td>
      <td>{Util.serverStringToDisplayDateTime(room.created_date)}</td>
      <td>
        { this.Update ?
          <span onClick={() => this.props.edit(room, TowerConst.Room)} className="buttons update">
            <FaPencilAlt /> Edit
          </span>
        : null }
        { this.Delete ?
          <span onClick={() => this.onDelete(_i)} className="buttons delete"><FaTrash /> Delete</span>
          : null
        }
      </td>
    </tr>
  ));

  showPopUp = (model, field, indx) => {
    let tmp = { ...this.state };
    tmp[field] = model;
    tmp.popup = field;
    this.setState({ ...tmp });
  }

  hidePopUp = () => this.setState({ ...this.state, popup: InnerRoomList.Refresh});
    
  render() {
    let uiCalls = this.showList();
    if (this.state.rooms.length === 0) {
      uiCalls = <tr><td colSpan="9">No Records Found</td></tr>;
    }
    return (
      <div className="row">
        <div className="col-md-12">
          <ApiUiController inApiCall={this.state.inApiCall}>
            <div className="col-md-12">
              <Table>
                <thead>
                  <tr>
                    <th><h2>{this.model.model_name}</h2></th>
                    <th><FieldSelect key="property" id="property" field={this.model.fields.property}
                        value={this.state.room.property} onValueChange={this.onChange} inValid={{}} /></th>
                    <th><FieldSelect key="room_status" id="room_status" field={this.model.fields.room_status}
                        value={this.state.room.room_status} onValueChange={this.onChange} inValid={{}} /></th>
                    <th><span onClick={this.applyFilter} className="buttons btn-success"><FaCheck /> Filter</span></th>
                    { this.Delete ?
                      <th><span onClick={this.onMassDelete} className="buttons delete"><FaTrash /> Mass Delete</span></th>
                      : null
                    }
                  </tr>
                </thead>
              </Table>
            </div>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th></th>
                  <th>{this.model.fields.room_name.label_name}</th>
                  { this.model.fields.floor_no.visible ? <th>{this.model.fields.floor_no.label_name}</th> : null }
                  <th>{this.model.fields.property.label_name}</th>
                  <th>{this.model.fields.room_status.label_name}</th>
                  <th>Customer Name</th>
                  <th>Updated By</th>
                  <th>Updated Date</th>
                  <th>Created By</th>
                  <th>Created Date</th>
                  <th className="actionth">Action</th>
                </tr>
              </thead>
              <tbody>{uiCalls}</tbody>
            </Table>
          </ApiUiController>
        </div>
      </div>
    );
  }
}

export default withRouter(InnerRoomList);
